import React, { type ReactNode } from 'react'
import { css } from '@linaria/core'
import { sanitizeProps } from '@fs/zion-frontend-friends'

const sizes = {
  xs: 24,
  sm: 40,
  md: 64,
  lg: 88,
  xl: 136,
  xxl: 180,
}

const iconCss = css`
  display: block;
`
export type IconProps = {
  role?: string
  'aria-label'?: string
  size?: keyof typeof sizes
  color?: string
}

const BaseIcon = ({
  role = 'img',
  'aria-label': label,
  size = 'sm',
  color = 'currentColor',
  children,
  ...props
}: IconProps & { children: ReactNode }): JSX.Element => (
  <svg
    className={iconCss}
    role={role}
    aria-label={label}
    viewBox="0 0 24 24"
    width={sizes[size]}
    height={sizes[size]}
    fill={color}
    {...sanitizeProps(props)}
  >
    {children}
  </svg>
)

export default BaseIcon
